import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
import modalCommentPayment from '../modal-comment-payment/modal-comment-payment.view.html';
let inject = [
  '$scope',
  'DetailedPaymentService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  'NgTableParams',
  'ngAuthSettings'
];

class PayZoneDashboardController{
  constructor ($scope, DetailedPaymentService, $state, $rootScope, SharedService, $uibModal, NgTableParams, ngAuthSettings) {
    this.$state = $state;
    this.NgTableParams = NgTableParams;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.DetailedPaymentService = DetailedPaymentService;
    this.SharedService = SharedService;
    this.loanding = false;
    this.payment = {};
    this.billfoldResume = null;
    this.tab = 1;
    this.getTableHeight = 'height: 30px';
    this.bills = [];
    this.urlPay = this.ngAuthSettings.config.env.apiEndPoint + '/recaudos/recaudos/pay-gate';
    this.$scope.gridOptions = {
      columnDefs:[
        {
          field: 'detalle_numero_documento',
          displayName: 'No. Doc.',
          enableCellEdit : false,
          headerCellClass: 'gridHeaderCustom',
          cellClass : 'gridCellCustom'
        },
        {
          field: "detalle_fecha_documento",
          displayName: "Fecha Emisión",
          enableCellEdit : false,
          headerCellClass: 'gridHeaderCustom',
          cellClass : 'gridCellCustom'
        },
        {
          field: "detalle_fecha_vencimiento",
          displayName: "Fecha Vencimiento",
          enableCellEdit : false,
          headerCellClass: 'gridHeaderCustom',
          cellClass : 'gridCellCustom'
        },
        {
          field: "detalle_saldo_documento",
          displayName: "Vr. pte. de pago",
          enableCellEdit : false,
          cellFilter : 'currency',
          headerCellClass: 'gridHeaderCustom',
          cellClass : 'gridCellCustom'
        },
        {
          field: "valor_recaudo",
          displayName: "Vr. a pagar hoy",
          cellFilter : 'currency',
          cellEditableCondition : (scope) => {
            return (scope.row.entity.operation === 'Pago completo' || scope.row.entity.operation === 'Abono') && scope.row.entity.activate;
          },
          editableCellTemplate : `<div >
                                      <input
                                          type="text"
                                          class="input-editable"
                                          restrict-type="numValues"
                                          ng-class="'colt' + col.uid"
                                          ui-grid-editor
                                          maxlength="10"
                                          ng-blur="grid.appScope.$ctrl.changeValor(row.entity)"
                                          ng-model="MODEL_COL_FIELD"/>
                                  </div>`,
          headerCellClass: 'gridHeaderCustom',
          cellClass : 'gridCellCustom'
        },
        {
          field: "selection",
          displayName: "-",
          enableCellEdit : false,
          enableSorting: false,
          enableFiltering: false,
          headerCellClass: 'gridHeaderCustom',
          cellTemplate: ` <div>
                              <input
                                type="checkbox"
                                ng-model="row.entity.activate"
                                ng-change="grid.appScope.$ctrl.activateBill(row.entity)"
                                ng-disabled="row.entity.operation === 'Saldo a Favor'"
                                id="check-3">
                          </div>`,
          cellClass : 'gridCellCustom'
        },
        {
          field: "operation",
          rowHeight: 5,
          displayName: "Operación",
          enableCellEdit : false,
          headerCellClass: 'gridHeaderCustom',
          cellClass : 'gridCellCustom'
        }
      ],
      data: this.bills,
      enableSorting: true,
      enableFiltering: true,
      virtualizationThreshold: 100,
      enableColumnMenus: false,
      paginationPageSizes: [25, 50, 75],
      paginationPageSize: 50,
      enableRowSelection: true,
      enableGridMenu: false,
      enableRowHeaderSelection: false,
      lang : 'es',
      enableColumnResize: true,
      multiSelect: false,
      cellTooltip: true,
      enableCellEditOnFocus : true,
      onRegisterApi: (gridApi) => {
        this.$scope.gridApi = gridApi;
      },
      enableHorizontalScrollbar : 0
    }
  }

  $onInit(){
    this.getDatas();
  }

  getDatas() {
    let result = this.DetailedPaymentService.getPayment();
    if(!result) this.$state.go('home.detailZone');
    else {
      this.payment = result;
      this.payment.recaudo = 0;
      this.payment.recaudo_total = 0;
      // this.DetailedPaymentService.getBillfold('10018629').then(response => {
      this.DetailedPaymentService.getBillfold(this.shCtrl.globals.currentUser.thirdDocumentNumber).then(response => {
        if(!response) response = [];
        response.forEach(val => {
          if(angular.isString(val.detalle_valor_documento)) val.detalle_valor_documento = parseInt(val.detalle_valor_documento);
          if(angular.isString(val.detalle_saldo_documento)) val.detalle_saldo_documento = parseInt(val.detalle_saldo_documento);
          this.payment.recaudo += val.detalle_saldo_documento;
          val.valor_recaudo = val.detalle_saldo_documento;
          val.numero_documento = val.detalle_numero_documento;
          val.activate = false;
          if(val.valor_recaudo < 0){
            val.operation = 'Saldo a Favor';
          } else {
            val.operation = 'Pago completo';
          }
        });
        this.bills = response.filter(val =>  {return val.detalle_saldo_documento > 0});
        this.getTableHeight = 'height: ' + (30 * this.bills.length) + 'px';
        this.$scope.gridOptions.data = this.bills;
      });
    }
  }

  getBill(detalle_numero_documento){
    let result = this.bills.filter(val => val.detalle_numero_documento === detalle_numero_documento);
    return result.length ? this.bills.indexOf(result[0]) : false;
  }

  activateBill(bill){
    // let billIndex = getBill(bill.detalle_numero_documento);
    if(!bill.activate) {
      bill.valor_recaudo = bill.detalle_saldo_documento;
    } else {
      this.changeValor(bill);
    }
    this.changeTotals();
  }

  cancelTransaction(){
    let options = {
      title : 'CANCELAR TRANSACCIÓN',
      isHtml : false,
      content : '¿Desea cancelar el pago?',
      showBottonCancel : true,
      size : 'sm',
      textActionCancel : 'Cancelar',
      textAction : 'Continuar Transacción'
    };
    this.messageResponse(options, false, null , true, () => {this.$state.go('home.detailZone')});
  }

  changeValor(bill) {
    if(angular.isString(bill.valor_recaudo)){
      bill.valor_recaudo = bill.valor_recaudo.replace(/[,]/g, '');
      bill.valor_recaudo = parseInt(bill.valor_recaudo);
    }
    if(!bill.valor_recaudo || bill.valor_recaudo == 0) {
      bill.valor_recaudo = bill.detalle_saldo_documento;
      bill.operation = 'Pago completo';
      alert('Valor a pagar es requerido.');
    } else if(bill.valor_recaudo > bill.detalle_saldo_documento) {
      bill.valor_recaudo = bill.detalle_saldo_documento;
      bill.operation = 'Pago completo';
      alert('Valor a pagar no puede ser mayor al valor del documento.');
    } else if(bill.valor_recaudo == bill.detalle_saldo_documento){
      bill.operation = 'Pago completo';
    }else if(bill.valor_recaudo < bill.detalle_saldo_documento){
      bill.operation = 'Abono';
    }
    this.changeTotals();
  }

  changeTotals(){
    this.payment.recaudo_total = 0;
    this.$scope.gridOptions.data.forEach(val => {
      if(val.activate) this.payment.recaudo_total += val.valor_recaudo;
    });
  }

  submitDetail(){
    this.changeTotals();
    let result = this.$scope.gridOptions.data.filter(val => { return val.activate;});
    if(result.length){
      this.payment.bills = result;
      this.tab = 2;

    } else {
      alert('Debe seleccionar al menos una factura a pagar');
    }
  }

  openPaymentComment(){

    let options = {
      comment : this.payment.observaciones
    };

    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalCommentPayment,
      controller : 'CommentPaymentModalController',
      controllerAs : 'mdCtrl',
      size: '',
      resolve : {
        modalOptions : () => options
      }
    });

    modalInstance.result.then(comment => {
      this.payment.observaciones = comment;
    }).catch(reason => {
    });
  }

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
}

PayZoneDashboardController.$inject = inject;

export default PayZoneDashboardController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/detailed-payment/detailed-payment.controller.js
 **/